import { useState } from 'react'
import { PropTypes } from 'prop-types'
import './styles.scss'

const Tooltip = ({ content, children, direction = 'top', distance = 30, tooltipBgc = 'black' }) => {
  const [active, setActive] = useState(false)

  const customCssVariables = {
    '--raychat-tooltip-text-color': 'white',
    '--raychat-tooltip-background-color': tooltipBgc,
    '--raychat-tooltip-margin': `${distance}px`,
    '--raychat-tooltip-arrow-size': '6px',
  }

  const showTip = () => {
    setActive(true)
  }

  const hideTip = () => {
    setActive(false)
  }

  // adds raychat prefix to the direction to prevent className conflict
  const getClassName = (direction) => {
    return `tooltip_direction_${direction}`
  }

  return (
    <div
      className="tooltip_Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      style={customCssVariables}
    >
      {/* Wrapping */}
      {children}
      {content && (
        <div className={`tooltip_tip ${active ? 'tooltip_show' : ''} ${getClassName(direction)}`}>{content}</div>
      )}
    </div>
  )
}

Tooltip.propTypes = {
  distance: PropTypes.number,
  tooltipBgc: PropTypes.string,
  direction: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  content: PropTypes.string,
}

export default Tooltip
